import React, { Fragment } from 'react';
import NavigationTabs from '../nav/NavigationTabs';
import Button from '@material-ui/core/Button';
import ButtonContent from '../ButtonContent'
import compose from 'recompose/compose';
import { connect } from "react-redux";
import { fetchAll } from "../../store/actions/brand";
import AlertMessage from '../AlertMessage';
import withAuth from '../../hocs/withAuth';
import { withStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { COLORS } from '../../styles/colors';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadMoreIcon from './../LoadMoreIcon';
import SearchInput from './../SearchInput';


const styles = theme => ({
    root: {
        flexGrow: 1,
      },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        margin: theme.spacing(2, 0),
    },
});
const titleButtonRow = {
    position: 'relative',
}
const titleButton = {
    position: 'absolute',
    top: '-50px',
    right: '0'
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const movedItem = result.find((item, index) => index === startIndex);
  const remainingItems = result.filter((item, index) => index !== startIndex);
  const reorderedItems = [
    ...remainingItems.slice(0, endIndex),
    movedItem,
    ...remainingItems.slice(endIndex)
  ];
  return reorderedItems;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgray" : "white",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "#f2f3f4",
  padding: grid,
  width: 800
});

class TrainerListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: '',
      showSuccessMessage: false,
      isChangedOrder: false,
      successMsg: '',
      listing: []
    }
  }

  componentDidMount () {
    this.props.fetchAll();
  }

  static getDerivedStateFromProps(props, state) {
    let updateSate  = null;
    const { listing } = props;
    if (state.listing && state.listing.length) {
      updateSate = {
        listing: state.listing
      }
    } else {
        const filterListing = listing && listing.filter((item)  => {
          return !item.isCorporate
        });
        let updatedListing = filterListing && filterListing.map((item, index) => {
            return {
                _id: item._id,
                displayName: item.displayName,
                order: item.order
            }
        })
        updatedListing.sort(function(a, b) {
          return a.order - b.order;
        });
        updateSate = {
            listing: updatedListing
        }
    }
    return updateSate;
  }

  renderTrainerListing() {
      const { listing, search } = this.state;
      const { isLoadTrainerMore } = this.props
      let data = [];
      let filterListing = listing;
      if(search && search !== '') {
        filterListing = listing.filter((list) => {
          return list.displayName && list.displayName.toLowerCase().includes(search.toLowerCase())
        })
      }
      if (filterListing && filterListing.length === 0) {
        return (
          <div style={{
            color:COLORS.red,
            height:200,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}><strong>No Trainer Found.</strong></div>
        );
      }
      if (filterListing && filterListing.length > 0) {
                        return (
                        
                        <InfiniteScroll
                                    dataLength={filterListing.length} //This is important field to render the next data
                                    next={() => fetchAll(listing.length)}
                                    hasMore={isLoadTrainerMore}
                                    scrollableTarget="scrollableActions"
                                    loader={
                                        <LoadMoreIcon/>
                                    }
                            >
                            {filterListing.map((item, index) => (
                                <Fragment>
                                 
                                    <div className="listItem" key={index}>
									<div
										style={{
											width: '90%',
											display: 'flex',
											alignItems: 'center',
										}}
									>
										<div className="nowrap">
											<b>{item.displayName} </b>
											<br />
										</div>
									</div>
									<div style={{ width: '10%' }}></div>
								</div>

                                
                                </Fragment>
                            ))}
                    </InfiniteScroll>)
      }
  }

  onDragEnd = (result) =>  {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      this.state.listing,
      result.source.index,
      result.destination.index
    );

    this.setState({
      isChangedOrder: true,
      listing: items,
    });
  }

  render() {
    const { errors } = this.props;
    return (
      <div>
        <NavigationTabs
          title={`Manage Trainers`}
          set={'manageTrainers'}
          subtitle={`Trainer Listing`}
          activeRoute={'/manageTrainers/listing'}/>
        <div style={titleButtonRow}>
          {
            this.state.showErrorMessage ? (
              <AlertMessage
                subject="Channels Order Changed!"
                body={this.state.successMsg}
                icon={['far','check-square']}
                />
            ) : null
          }
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
          <div
					style={{
						borderTop: '1px solid ' + COLORS.grey,
						backgroundColor: COLORS.greyFour,
						paddingTop: 10,
						paddingBottom: 5,
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'column',
					}}
				>
          <div>
							<SearchInput
								value={this.state.search}
								onChange={e =>
									this.setState({ 
                    ...this.state, 
                    search: e.target.value 
                  })
								}
							/>
						</div>
            </div>
             {this.renderTrainerListing()}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    listing: state.brand && state.brand.trainerListing,
    errors: state.errors,
    isLoadTrainerMore: state.brand && state.brand.isLoadTrainerMore,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAll: () => {
      return dispatch(fetchAll(true, false));
    }
  }
}

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(withAuth(TrainerListing));




// WEBPACK FOOTER //
// ./src/components/manageBrands/TrainerListing.js